<template>
  <div v-if="showBuyNow" class="ta-lot-buy-now-price-wrapper">
    <div v-if="lot.buy_now_price && label" class="ta-lot-buy-now-price-label">
      {{ label }}
    </div>
    <span class="ta-lot-list-item-price ta-lot-buy-now-price">
      <template v-if="lot.buy_now_price">{{ lot.buy_now_price | asCurrency(lot.currency.code) }}</template>
      <template v-else>({{ $t('Empty')}})</template>
    </span>
  </div>
</template>

<script>
import lotBaseMixin from "@/mixins/lotBaseMixin";

export default {
  name: "LotBuyNowPrice",
  mixins: [lotBaseMixin],
  props: {
    label: {
      type: [String, Boolean],
      default() {
        return this.$t('Buy now')
      }
    },
    lot: {
      required: true,
      type: Object
    },
    showEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    biddingStarted() {
      return this.lot.biddingStarted
    },
    biddingFinished() {
      return this.lot.biddingFinished
    },
  }
}
</script>

<style scoped>

</style>
